<template>
  <div class="relative" id="app">
    <router-view></router-view>
    <div v-if="!isAdminRoute">
      <div
        class="top78 left92 fixed z-10 cursor-pointer lg:block md:block hidden"
      >
        <!-- https://tinyurl.com/bde2hbmp -->
        <div class="floating-translate-wrapper control relative"></div>
        <div class="flex items-end gap-1">
          <div>
            <div class="translate" @click="toggleTranslateMenu"></div>

            <div
              v-if="showTranslateMenu"
              class="floating-options"
              @mouseenter="keepTranslateMenuOpen"
              @mouseleave="hideTranslateMenu"
            >
              <div
                v-for="country in countries"
                :key="country.title"
                class="option"
                @click="doTranslation(country.code)"
              >
                <img
                  :src="country.flagIconUrl"
                  :alt="
                    country.altText
                      ? country.altText
                      : `${country.title} flag icon`
                  "
                  class="option-icon"
                />
                <span>
                  {{ country.title }}
                </span>
              </div>
            </div>
            <div
              @click="
                handleclick(
                  'request-form',
                  'request-for-service-want-care-attendent'
                )
              "
            >
              <div class="control relative mt-4">
                <div class="job"></div>
                <div class="green"></div>
              </div>
            </div>
            <a
              href="https://chat.whatsapp.com/H4TUoGPJGIpJJ3b5NXHUNe"
              target="_blank"
            >
              <div class="control relative mt-4">
                <div class="whatsApp"></div>
                <div class="green1"></div>
              </div>
            </a>
          </div>
          <a
            href="https://nexuscluster.blob.core.windows.net/server01/caregiversaathi-new/community%20guidelines.txt"
            target="_blank"
          >
            <p
              class="fsize12 text-white bg-primary p-1 rounded-full line-vert hov-text"
            >
              <feather-icon
                icon="InfoIcon"
                svgClasses="w-4 h-4"
                class="flex infoicon"
              />
              <span class="infotext py-2">Know our Community Guidelines</span>
            </p>
          </a>
        </div>
        <!-- <a href="https://tinyurl.com/bde2hbmp" target="_blank">
          <img
            src="./assets/images/JobIcon1.png"
            alt="whatsapp"
            class="float-icon"
        /></a>
        <a
          href="https://chat.whatsapp.com/H4TUoGPJGIpJJ3b5NXHUNe"
          target="_blank"
        >
          <img
            src="./assets/images/Frame 89.png"
            alt="whatsapp"
            class="float-icon mt-2"
          />
        </a> -->
      </div>
      <div
        class="top78 left92 fixed z-10 cursor-pointer lg:hidden md:hidden block"
      >
        <div class="floating-translate-wrapper control relative">
          <div class="translate mb-1" @click="toggleTranslateMenu"></div>

          <div
            v-if="showTranslateMenu"
            class="floating-options"
            @mouseenter="keepTranslateMenuOpen"
            @mouseleave="hideTranslateMenu"
          >
            <div
              v-for="country in countries"
              :key="country.title"
              class="option"
              @click="doTranslation(country.code)"
            >
              <img
                :src="country.flagIconUrl"
                :alt="
                  country.altText
                    ? country.altText
                    : `${country.title} flag icon`
                "
                class="option-icon"
              />
              <span>
                {{ country.title }}
              </span>
            </div>
          </div>
        </div>
        <div>
          <a href="https://tinyurl.com/bde2hbmp" target="_blank">
            <div class="control relative">
              <div class="job"></div>
            </div>
            <!-- <img src="./assets/images/JobIcon.png" alt="job" class="h-16" /> -->
          </a>
        </div>

        <a
          href="https://chat.whatsapp.com/H4TUoGPJGIpJJ3b5NXHUNe"
          target="_blank"
        >
          <div class="control relative mt-16">
            <div class="whatsApp"></div>
          </div>
          <!-- <img
            src="./assets/images/new/w.png"
            alt="job"
            class="h-16 mt-2 rounded-full"
          /> -->
        </a>
      </div>
    </div>

    <!-- <b-modal
      id="translate-modal2"
      size="sm"
      title="Translate site"
      class="sm-mod"
      hide-backdrop
      scrollable
      @show="changeVal"
      ok-title="Continue"
    >
      <Translator :countries="countries" @on-country-click="hideModal" />
    </b-modal> -->
  </div>
</template>

<script>
import API from "@/apis";
import brandingMixin from "@/mixins/branding";
// import moduleCMS from "@/views/social/admin/pages/blog/store/index";
// import moduleCMSTag from "@/views/social/admin/pages/add-tags/store/index";
import TranslateModal from "./views/navbar/components/TranslateModel.vue";
import { Translator } from "vue-google-translate";
import TranslateModel from "./views/navbar/components/TranslateModel.vue";

// C:\brained\caregiver-saathi\src\views\navbar\components\TranslateModel.vue

export default {
  components: { TranslateModal, Translator, TranslateModel },

  mixins: [brandingMixin],
  data() {
    return {
      selectedCode: "",
      showTranslateMenu: false,
      hasClickListener: true,
      isAdminRoute: false,
      checkbox1: false,
      checkbox2: false,
      countries: [
        {
          code: "en|hi",
          title: "हिन्दी",
          flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/in.svg",
          altText: "Hindi language translation",
        },
        {
          code: "en|en",
          title: "English",
          flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/gb.svg",
        },
      ],
    };
  },
  methods: {
    languageSelectedHandler(info) {
      // console.log(info);
    },
    setLang(val) {
      localStorage.setItem("selectedLang", val);
      if (val === "hindi") {
        this.$refs.targetHindi.click();
      }
    },
    changeVal() {
      let selectedLang = localStorage.getItem("selectedLang");
      if (selectedLang === "hindi") {
        this.checkbox1 = true;
        this.checkbox2 = false;
        let myLang = document.getElementById(selectedLang);
        myLang.style.border = "8px solid red";
      } else if (selectedLang === "eng") {
        this.checkbox2 = true;
        this.checkbox1 = false;
      }
    },
    handleclick(name, params) {
      this.$router.push({ name: name, params: { pathName: params } });
    },
    async getClientDetails() {
      try {
        const { data } = await API.client.getClientDetails();

        const params = {
          colors: {
            primary: data.data.primaryColor,
          },
        };
        const style = this.ApplyBranding(params);

        this.setStyles(style);

        this.setFavicon(`${this.$imageURL}/${data.data.favicon}`);

        // SET BRAND LOGO
        this.$store.commit("brand/SET_BRAND_DETAIL", {
          key: "logo",
          value: `${this.$imageURL}/${data.data.logo}`,
        });

        this.$store.commit("brand/SET_BRAND_DETAIL", {
          key: "favicon",
          value: `${this.$imageURL}/${data.data.favicon}`,
        });

        this.$store.commit("brand/SET_BRAND_DETAIL", {
          key: "primaryColor",
          value: data.data.primaryColor,
        });
      } catch (error) {
        if (error) {
          // TODO
        }
      }
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    },
    // hideModal() {
    //   this.$bvModal.hide("translate-modal2");
    // },
    hideTranslateMenu() {
      this.showTranslateMenu = false;
    },
    toggleTranslateMenu() {
      this.showTranslateMenu = !this.showTranslateMenu;
    },
    keepTranslateMenuOpen() {
      this.showTranslateMenu = true;
    },
    doTranslation(code) {
      this.selectedCode = code;
      this.handleOk();
      if (this.hasClickListener) {
        this.$emit("click", code);
      }
    },
    handleOk() {
      this.$emit("click", this.selectedCode);
      if (
        typeof window !== "undefined" &&
        typeof window.doGTranslate === "function"
      ) {
        if (!this.selectedCode || !this.selectedCode.includes("|")) {
          console.error("Invalid language code format:", this.selectedCode);
          return;
        }

        try {
          window.doGTranslate(this.selectedCode);
          localStorage.setItem("lang", this.selectedCode);
        } catch (error) {
          console.error("Error in doGTranslate function:", error);
        }
      } else {
        console.error(
          "window.doGTranslate is not available or is not a function."
        );
      }
    },
  },
  mounted() {
    // let lang = localStorage.getItem("selectedLang");
    // if (!lang) {
    //   localStorage.setItem("selectedLang", "eng");
    // }
    // this.$bvModal.show("translate-modal2");
    // this.$refs.translate.openTranslateModal();
  },
  created() {
    // this.$store.registerModule("cms", moduleCMS);
    // this.$store.registerModule("cmstag", moduleCMSTag);
    window.addEventListener("resize", this.handleWindowResize);
  },

  watch: {
    "$route.path"(val) {
      let data = val.split("/")[1];
      // console.log(data);
      if (data === "admin") {
        this.isAdminRoute = true;
      } else {
        this.isAdminRoute = false;
      }
    },
    checkbox1(newVal) {
      if (newVal) this.checkbox2 = false;
    },
    checkbox2(newVal) {
      if (newVal) this.checkbox1 = false;
    },
  },

  computed: {
    hasClickListener() {
      return Object.keys(this.$listeners).includes("on-country-click");
    },
    // console.warn(this.$route);
  },
  // destroyed() {
  //   this.$store.unregisterModule("cms", moduleCMS);
  //   this.$store.unregisterModule("cmstag", moduleCMSTag);
  // },
};
</script>
<style>
/* body > .skiptranslate {
  display: none;
} */
.goog-te-gadget {
  display: none !important;
}
body > .skiptranslate {
  display: none;
}

body {
  top: 0px !important;
}
.float-icon {
  width: 220px !important;
  height: 55px !important;
}
.top78 {
  bottom: 5%;
}
@font-face {
  font-family: "Nunito";
  src: local("Nunito"),
    url(./fonts/Nunito/Nunito-Regular.ttf) format("truetype");
}

.job {
  width: 59px;
  height: 60px;
  background: url("./assets/images/new/j1.png");
  position: absolute;
  top: 0;
  z-index: 2;
  border-radius: 50px 50px;
}
.green {
  width: 59px;
  left: 92vw;
  height: 60px;
  background: url("./assets/images/new/24aa.png");
  /* transition-property: width;
  transition-duration: 500ms;
  transition-delay: 250ms; */
  transform: translateX(0);
  /* z-index: 1; */
  transition: transform 500ms ease, width 500ms ease;
  opacity: 0;
  border-radius: 50px 50px;
}

.job:hover + .green {
  width: 220px;
  transform: translateX(-160px);
  opacity: 1;
  border-radius: 50px 50px 50px 50px;
}
.whatsApp {
  width: 59px;
  height: 60px;
  background: url("./assets/images/new/w.png") no-repeat;
  position: absolute;
  top: 0;
  z-index: 2;
  border-radius: 50px 50px;
}
.green1 {
  width: 59px;
  height: 60px;
  background: url("./assets/images/new/25a.png") no-repeat;
  /* transition-property: width;
  transition-duration: 500ms;
  transition-delay: 250ms; */
  transform: translateX(0);
  transition: transform 500ms ease, width 500ms ease;
  opacity: 0;
  border-radius: 50px 50px;
}
.whatsApp:hover + .green1 {
  width: 220px;
  opacity: 1;
  transform: translateX(-160px);
  border-radius: 50px 50px 50px 50px;
}

.floating-translate-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@media (max-width: 640px) {
  .top78 {
    bottom: 12% !important;
  }
}
.translate {
  width: 59px;
  height: 60px;
  background: url("./assets/images/new/f4.jpg");
  background-size: cover;
  border: 2px solid #4f0a4b;
  border-radius: 50%;
  cursor: pointer;
}

.floating-options {
  position: absolute;
  top: -28px;
  left: -135px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.option {
  display: flex;
  align-items: center;
  gap: 10px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 50px;
  padding: 5px 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.option:hover {
  background-color: #f1f1f1;
}

.option-icon {
  width: 40px;
  height: 40px;
  border-radius: 35%;
  background-size: cover;
}

.option span {
  font-size: 14px;
  color: #333;
}
</style>
